<template>
  <alert
    v-if="visible"
    type="info"
    class="opc-open-invoice-alert"
    :show-icon="false"
    :closable="false"
  >
    <i slot="icon" class="zm-icon-info" style="color: #9191A4;"></i>
    <p>{{ warningLabel }}</p>
  </alert>
</template>

<script>
import { mapGetters } from 'vuex';
import Alert from '@/components/zoom-ui-plus/alert/alert';

export default {
  name: 'open-invoice-alert',
  components: { Alert },
  computed: {
    ...mapGetters(['existOpenInvoice', 'openInvoiceCount']),
    visible() {
      return this.existOpenInvoice;
    },
    warningLabel() {
      return this.$t('billing.invoice.warning');
    },
  },
};
</script>

<style lang="scss">
.opc-open-invoice-alert {
  margin-bottom: 16px;
  align-items: center;
  background: #F7F7F8;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #515079;

  .zm-icon-info {
    font-size: 16px;
  }
}

.zm-theme--dark {
  .opc-open-invoice-alert {
    p {
      color: #98a0a9;
    }
  }
}
</style>
